import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

export const useSessionCheck = (callback) => {
    const navigate = useNavigate()
    const email = sessionStorage.getItem("email")


    useEffect(() => {
        if (!callback) {
            if (window.location.host.includes("localhost") || window.location.host.includes("192.168.0.201")) return
            if (!email) navigate("/error")
        } else {
            callback()
        }
    })
    return email
}